<div fxLayout>
  <sbnb-subnav fxFlex="280px" fxHide.lt-md [header]="'SETTINGS.SETTINGS' | transloco">
    <sbnb-settings-subnav></sbnb-settings-subnav>
  </sbnb-subnav>

  <main fxFlex class="subnav__exists" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <app-feature-flag-tabs>
      <sbnb-page-header navTabs>
        <h2 class="mb-0" fxLayout fxLayoutAlign="space-apart center">
          <span fxFlex>Billing Details</span>
          <sbnb-save-indicator [saveStatus]="saveStatus"></sbnb-save-indicator>
        </h2>
      </sbnb-page-header>
      <h2 class="mb-0" fxLayout fxLayoutAlign="space-apart center">
        <span fxFlex>Billing Details</span>
        <sbnb-save-indicator [saveStatus]="saveStatus"></sbnb-save-indicator>
      </h2>
    </app-feature-flag-tabs>

    <hr />

    <mat-spinner *ngIf="loading" [diameter]="32"></mat-spinner>

    <sbnb-billing-form *ngIf="!loading"></sbnb-billing-form>
  </main>
</div>

<sbnb-mobile-sidebar [navTabsHide]="true" [title]="'Settings'">
  <sbnb-settings-subnav></sbnb-settings-subnav>
</sbnb-mobile-sidebar>
